import React, { ComponentPropsWithoutRef, FC } from 'react';
import { Link } from 'react-router';
import cx from 'classnames';

import { formatter, url } from 'helpers';
import { Paragraph, QrCode } from 'components/ui';
import { Override } from 'types/common';
import { InvoiceBasic } from 'types/models';

import styles from './styles.module.css';

type InvoiceQrProps = Override<ComponentPropsWithoutRef<'div'>, {
  invoice: InvoiceBasic;
}>;

const InvoiceQr: FC<InvoiceQrProps> = ({
  className,
  invoice,
  ...props
}) => {
  const invoiceLink = url.toInvoicePaymentFull(invoice.displayId);

  return (
    <div className={cx(styles.root, className)} {...props}>
      <Paragraph className={styles.purpose}>{invoice.purpose}</Paragraph>
      <Paragraph className={styles.amount}>
        {formatter.formatCurrency(invoice.amount, invoice.currency)}
      </Paragraph>
      <QrCode className={styles.qr} value={invoiceLink} />
      <div className={styles.link}>
        <Link to={invoiceLink} target="_blank">{invoiceLink}</Link>
      </div>
    </div>
  );
};

export default InvoiceQr;
